import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AdminSellerService, SellerListItem } from '../../../_services/admin-seller.service';

@Component({
    selector: 'app-sellers-list',
    templateUrl: './sellers-list.component.html',
    styleUrls: ['./sellers-list.component.css'],
    standalone: false
})
export class SellersListComponent implements OnInit, OnDestroy {
    sellers: SellerListItem[] = [];
    filteredSellers: SellerListItem[] = [];
    loading = false;
    config: any;
    page = 1;
    itemPerPage = 10;
    
    // Filter
    statusFilter: 'ALL' | 'PENDING' | 'COMPLETED' | 'VERIFIED' | 'REJECTED' = 'ALL';

    constructor(
        private adminSellerService: AdminSellerService,
        private router: Router,
        private titleService: Title
    ) {
        this.titleService.setTitle('Sellers');
    }

    ngOnInit(): void {
        this.loadSellers();
    }

    ngOnDestroy(): void {
        this.titleService.setTitle('');
    }

    loadSellers(): void {
        this.loading = true;
        this.adminSellerService.listSellers().subscribe({
            next: (response) => {
                this.sellers = response.data.data;
                this.applyFilter();
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    applyFilter(): void {
        if (this.statusFilter === 'ALL') {
            this.filteredSellers = this.sellers;
        } else {
            this.filteredSellers = this.sellers.filter(seller => seller.status === this.statusFilter);
        }
        this.setupPagination();
    }

    onStatusFilterChange(status: 'ALL' | 'PENDING' | 'COMPLETED' | 'VERIFIED' | 'REJECTED'): void {
        this.statusFilter = status;
        this.page = 1;
        this.applyFilter();
    }

    setupPagination(): void {
        this.config = {
            currentPage: this.page,
            itemsPerPage: this.itemPerPage,
            totalItems: this.filteredSellers.length,
            id: 'sellers-listing'
        };
    }

    pageChange(page: number): void {
        this.page = page;
        this.setupPagination();
    }

    viewSellerDetails(seller: SellerListItem): void {
        this.router.navigate(['/admin', 'sellers', seller.id]);
    }

    getDisplayName(seller: SellerListItem): string {
        if (seller.sellerType === 'company') {
            return seller.companyName || 'Unknown Company';
        } else {
            return `${seller.firstName || ''} ${seller.lastName || ''}`.trim() || 'Unknown Seller';
        }
    }

    getPaymentMethod(seller: SellerListItem): string {
        if (!seller.paymentInfo) {
            return 'N/A';
        }
        if (seller.paymentInfo.paymentType === 'MOBILE_MONEY') {
            return seller.paymentInfo.mobileMoneyProvider || 'Mobile Money';
        } else if (seller.paymentInfo.paymentType === 'BANK') {
            return seller.paymentInfo.bankName || 'Bank Transfer';
        }
        return 'N/A';
    }

    getStatusClass(status: string): string {
        switch (status) {
            case 'PENDING':
                return 'badge bg-warning';
            case 'COMPLETED':
                return 'badge bg-info';
            case 'VERIFIED':
                return 'badge bg-success';
            case 'REJECTED':
                return 'badge bg-danger';
            default:
                return 'badge bg-secondary';
        }
    }
}
